import {
  FormInput,
  FormSelect,
  FormTextarea,
  Heading,
  Loader,
} from "@/components";
import useAdd from "./useAdd";
import { FormProvider } from "react-hook-form";
import {
  TAG_IDENTIFIER,
  DISPLAY_LABEL,
  LICENSE_SCOPE,
  HELPER_TEXT,
} from "./consts";
import { Button } from "@/components/ui";

const Add = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
  } = useAdd();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title="Add TnC Variable"
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
              <FormInput
                name={TAG_IDENTIFIER}
                control={form.control}
                label="Tag Identifier"
                placeholder="{Please enter}"
                error={errors[TAG_IDENTIFIER]?.message}
                isRequired={requiredFields.includes(TAG_IDENTIFIER)}
              />
              <FormInput
                name={DISPLAY_LABEL}
                control={form.control}
                label="Display Label"
                placeholder="Please enter"
                error={errors[DISPLAY_LABEL]?.message}
                isRequired={requiredFields.includes(DISPLAY_LABEL)}
              />
              <FormSelect
                name={LICENSE_SCOPE}
                control={form.control}
                label="License Scope"
                placeholder="Please enter"
                error={errors[LICENSE_SCOPE]?.message}
                isRequired={requiredFields.includes(LICENSE_SCOPE)}
                options={[]}
              />
              <div className="col-span-2">
                <FormTextarea
                  name={HELPER_TEXT}
                  control={form.control}
                  label="Helper Text"
                  placeholder="Please enter"
                  error={errors[HELPER_TEXT]?.message}
                  isRequired={requiredFields.includes(HELPER_TEXT)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isAddPending}>
              {isAddPending && <Loader variant="secondary" />}
              Save
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default Add;
